<div *ngIf="reportType == 'InDetailCreditNote'">
  
    <div class="container" id="print-section">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="3">Vivek Saptahik</th>
                    <th colspan="4">Advt. Credit Note Register</th>
                    <th colspan="5">Date From  {{startDate | date: 'dd-MM-yyyy'}} To {{endDate | date: 'dd-MM-yyyy'}}</th>
                    <th colspan="2">In Details</th>
                </tr>
                <!-- <tr>
                    <th colspan="2">Datewise</th>
                    <th colspan="5">In Details</th>
                    <th colspan="3">Date From  {{startDate | date: 'dd-MM-yyyy'}} To {{endDate | date: 'dd-MM-yyyy'}}</th>
                    <th colspan="4">Page No</th>
                </tr> -->
                <tr>
                    <th>Credit Note No</th>
                    <th>CR Date</th>
                    <th>Advertiser<br>Name</th>
                    <th>Reprensantive<br>Name</th>
                    <th>Office Reprensantive<br>Name</th>
                    <th>Issue<br>Name</th>
                    <th>Issue<br>Date</th>
                    <th>Invoice<br>Number</th>
                    <th>Invoice<br>Date</th>
                    <th>Invoice Net<br>Amount</th>
                    <th colspan="2">Credit Amount</th>
                    <th>Total <br> Credit Amount</th>
                    <th>Remarks</th>
                </tr>
                <tr>
                    <th colspan="10"></th>
                    <th>TDS</th>
                    <th>Other</th>
                </tr>
            </thead>

            <tbody *ngFor="let data of advtCreditRegiInDetailsFormBeans; let i = index">
                
                <tr>
                    <td>{{data.credit_voc_no}}</td>
                    <td style="width:100%;">{{data.voc_date}}</td>
                    <td  style="font-weight: bold;">{{data.advt_name | slice : 0:30}}</td>
                    <td>{{data.rep_name}}</td>
                    <td>{{data.office_rep}}</td>
                    <td>{{data.DS_ISSUENAME | slice :0:20}} </td>
                    <td style="width:100%;">{{data.DS_ISSUEDATE}}</td>
                    <td>{{data.advt_invoice_no}}</td>
                    <td style="width:100%;">{{data.advt_invoice_date}}</td>
                    <!-- <td>{{data.net_amt}}</td> -->
                    <td style="text-align: end;font-weight: bold;">{{(data.net_amt * 1).toFixed(2)}}</td>
                    <td style="text-align: end;font-weight: bold;">{{(data.tds_amt * 1).toFixed(2)}}</td>
                    <td style="text-align: end;font-weight: bold;">{{(data.other_credit_amt * 1).toFixed(2)}}</td>
                    <td style="text-align: end;font-weight: bold;"> {{(data.credit_v_amt * 1).toFixed(2)}} </td>
                    <td style="text-align: left;">{{data.remark | slice : 0 :30}}</td>                    
                </tr>
            </tbody>

            
                <tr>
                  <td colspan="10" style="text-align: center; font-weight: bold;color: #060607;  background-color: #e9ecef;font-size: 15px;">Total:</td>
                  <td colspan="1" style="text-align: end; font-weight: bold;color: #060607;  background-color: #e9ecef;font-size: 15px;">{{(CredittadvtInDTotal * 1).toFixed(2)}}</td>
<td colspan="1" style="text-align: end; font-weight: bold;color: #060607;  background-color: #e9ecef;font-size: 15px;">{{(CredittadvtInDTotalother * 1).toFixed(2)}}</td>
<td colspan="1" style="text-align: end; font-weight: bold;color: #060607;  background-color: #e9ecef;font-size: 15px;">{{(CredittadvtInDTotalAmt * 1).toFixed(2)}}</td>
                  <td  style="text-align: end; font-weight: bold;color: #060607;  background-color: #e9ecef;font-size: 15px;"></td>
                </tr>
             
        </table>
        <!-- </div> -->
    </div>

    <div style="margin-left: 80%; margin-bottom: 2%;">
    <button 
  class="noPrint" 
  style="margin: 2% 2% 0 2%;" 
  (click)="exportExcel('Datewise_Subscription_Report')" 
  mat-raised-button 
  color="primary">
  Export
</button>

        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
           [useExistingCss]="true"
            printSectionId="print-section" ngxPrint>
            Print
        </button> -->


        <button class="btn btn-primary" (click)="printPage4()">Print</button>


	
        
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
</div>